import { useTranslation } from "react-i18next";
import { Typography, BottomSheetDialog } from "@foodpilot/foods";
import { FileUploadAttachmentDialogContent } from "./FileUploadAttachmentDialogContent";
import { usePropertyContext } from "../context/usePropertyContext";

export const FileUploadAttachmentDialog = () => {
    const { t } = useTranslation();

    const { attachmentState } = usePropertyContext();
    const { isUploadAttachmentDialogOpen, setOpenUploadDialog, attachments } = attachmentState;

    const dialogTitle =
        attachments.length > 0 ?
            t("property.attachment.manage_files", "Attached documents")
        :   t("property.attachment.add_file", "Add files");

    return (
        <BottomSheetDialog
            open={isUploadAttachmentDialogOpen}
            setOpen={setOpenUploadDialog}
            onClose={attachmentState.closeDialog}
            title={(<Typography variant="huge-bold">{dialogTitle}</Typography>) as any}
            content={(<FileUploadAttachmentDialogContent />) as any}
        />
    );
};
